import * as Types from "../constants/actionTypes";

export const updateImgZoomList = (imgZoom) => async (dispatch) => {
  dispatch({
    type: Types.IMG_ZOOM,
    payload: { imgZoom },
  });
};
